import React from "react";
import Hero from "./components/departments/Hero";
import Main from "./components/departments/Main";


function Departments (){
    return(
        <div>
            <Hero />
            <Main />
        </div>
    )
}
export default Departments;